module.exports = {"noMoreShowButton":"Již nezobrazovat"}